export default function numberRangeTostring(from, to) {
  // This generates a 3 parts string:  the "from" part, the conditional '_' part and the "to" part
  // It generates a string like '_10000', '10001_25000' or '1000000_'
  return [from, to].map(function (p) {
    return Number(p) || '';
  }).join('_');
}